import { atom } from "jotai";

import { currentModalStepAtom } from "../../stores";

export const enterMovePlayersBetweenGroupsStepAtom = atom(
  null,
  (_get, set, payload: { roundId: string }) => {
    set(currentModalStepAtom, {
      type: "MovePlayerBetweenGroups",
      roundId: payload.roundId,
    });
  }
);
